<template>
  <div class="exam_detail_box">
    <div class="detail_info_box">
      <div class="detail_info_tit">{{detaildata.title}}</div>
      <div v-html="detaildata.content" ></div>
    </div>
    
    <tab-bar :current-index="0" />  
  </div>
</template>
<script type="text/ecmascript-6">
import {
  Image as VanImage,
  Tab as VanTab,
  Tabs as VanTabs,
  Switch as VanSwitch,
  Button as VanButton,
  ImagePreview as VanImagePreview,
  Popup as VanPopup,
  Picker as VanPicker,
  Dialog as VanDialog,
  List as VanList,
  Toast
} from 'vant';
import Vue from "vue";
import API from "../api";
import axios from "axios";
import qs from 'qs';
import TabBar from '../components/tabbar.vue';
// import { Message } from 'element-ui'

export default {
  name: "",
  components: {
    TabBar,
   VanImage,
   VanTab,
   VanTabs,
   VanSwitch,
   VanButton,
   VanImagePreview,
   VanPopup,
   VanPicker,
   VanDialog,
   VanList,
  },
  data() {
    return {
      username: "",
      detailid:this.$route.params.id,
      detaildata:{},
    };
  },
  mounted() {
   this.getDetailInfo();
  //  this.getDataList();
  //  this.getTrendsList();
  },
  
  methods: {
    async getUserInfo(){ //用户信息
      const res = await API.getUserInfo();
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.userData = res.data.data;
        console.log(this.userData)
        //console.log(res.data.data.data1)
      } else {
        Toast(res.data.message);
      }
    },
    async getDetailInfo(){ //考试信息
      const params = {
        id: this.detailid
      };
      const res = await API.getDetailInfo(params);
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.detaildata = res.data.data;
        //console.log(this.examinfoData)
        //console.log(res.data.data.data1)
      } else {
        Toast(res.data.message);
      }
    },
    
   
  }
};
</script>
<style rel="stylesheet/stylus" type="text/stylus" scoped>

</style>



// WEBPACK FOOTER //
// detailinfo.vue?93945f0e